import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import fieldsDictionary from "../fieldsDictionary";
import { FieldViewType } from "../viewType";
import { fieldsType } from "@/utils/types/field";
import FaceliftFieldDetail from "./detail";
import FaceliftFieldEdit from "./edit";
import FaceliftFieldList from "./list";
/** <b>Composant qui contient l'affichage d'un champ de type facelift en: </b>
 *  <li>Liste</li>
 *  <li>Détails</li>
 *  <li>Édition</li>
 */
export function Facelift() {
    return _jsx(_Fragment, { children: "Facelift" });
}
var field = fieldsType.facelift;
fieldsDictionary.registerField(FieldViewType.DETAIL, field, FaceliftFieldDetail);
fieldsDictionary.registerField(FieldViewType.EDIT, field, FaceliftFieldEdit);
fieldsDictionary.registerField(FieldViewType.LIST, field, FaceliftFieldList);
